import { Injectable } from '@angular/core';
import { DataTransformAbstractGet } from 'app/modules/global/classes/data.transform.abstract.up';
import { CircuitInterface } from 'app/models/circuit.model';

@Injectable({
  providedIn: 'root',
})
export class CircuitDataTransformGet extends DataTransformAbstractGet {
  transform(circuit: CircuitInterface): CircuitInterface {
    return circuit;
  }
}
